import { TweenMax } from 'gsap';

export default function title(el) {
  TweenMax.set(el.parentNode, {
    perspective: 400,
  });

  TweenMax.set(el, {
    autoAlpha: 0,
    yPercent: 50,
    rotationZ: 20,
    scaleY: 1.5,
    transformOrigin: '0% 0%',
  });

  return el;
}
